import { observer } from 'mobx-react'

import { TaskDetail } from 'modules/tasks/components/TaskElement/useTaskDetail'

import { UploadDocumentsComponent } from './UploadDocumentsComponent'
import { useUploadDocumentFiles } from './useUploadDocumentFiles'

interface Props {
  title?: string
  description?: string
  fileSubtitle?: string
  task: TaskDetail
  employeeId: number
  documentName?: string
  folderId?: number
  canEmployeeManageAnyEmployeeFolder: boolean
}

const UploadDocuments = ({
  title,
  description,
  documentName,
  task,
  employeeId,
  folderId,
  fileSubtitle,
  canEmployeeManageAnyEmployeeFolder,
}: Props) => {
  const { loading, employee, canEditEmployeeDocuments, onAddFiles, fileOptions } =
    useUploadDocumentFiles({
      title,
      description,
      task,
      employeeId,
      documentName,
      folderId,
      canEmployeeManageAnyEmployeeFolder,
    })

  return (
    <UploadDocumentsComponent
      title={title}
      description={description}
      employee={employee}
      fileSubtitle={fileSubtitle}
      loading={loading}
      canEditEmployeeDocuments={canEditEmployeeDocuments}
      onAddFiles={onAddFiles}
      fileOptions={fileOptions}
    />
  )
}

export default observer(UploadDocuments)
